import * as React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { FaCalendarCheck, FaCalendarPlus, FaFileAlt, FaReceipt } from 'react-icons/fa';
import history from 'services/history';

const actions = [
  {
    title: 'Novo Agendamento',
    icon: <FaCalendarPlus size={40} />,
    path: '/paciente/agendamento-online',
  },
  {
    title: 'Meus Agendamentos',
    icon: <FaCalendarCheck size={40} />,
    path: '/paciente/agenda',
  },
  {
    title: 'Resultado de Exames',
    icon: <FaFileAlt size={40} />,
    path: '/frmatvpac',
  },
  {
    title: 'Receitas',
    icon: <FaReceipt size={40} />,
    path: '/paciente/receitas',
  },
];

export default function Dashboard() {
  const handleClick = (path) => history.push(path);

  return (
    <Container className="mt-4">
      <Row className="g-4 justify-content-center">
        {actions.map(({ title, icon, path }) => (
          <Col xs={12} sm={6} md={3} key={title}>
            <Card
              role="button"
              tabIndex={0}
              onClick={() => handleClick(path)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') handleClick(path);
              }}
              className="h-100 text-center shadow-sm border-0 dashboard-card"
            >
              <Card.Body className="d-flex flex-column align-items-center justify-content-center py-4">
                <div className="text-primary mb-3">{icon}</div>
                <Card.Title as="h5" className="fw-semibold text-dark m-0">
                  {title}
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
